import SuperagentBase from './superagent-base';

export default class ResourceBase extends SuperagentBase {
    constructor(model) {
        super();
        this.model = model;
        this.apiResource = model.__name__.toLowerCase() + 's';
    }

    getAll(token) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/${this.apiResource}`)
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    find(token, filter, filterString) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/${this.apiResource}${filterString ? '?' + filterString : ''}`)
                .query(filter ? filter : {})
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    findCount(token, filter) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/${this.apiResource}/count`)
                .query(filter ? filter : {})
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    getById(token, modelId, filterString) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/${this.apiResource}/${modelId}${filterString ? '?' + filterString : ''}`)
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    post(token, modelJSON) {
        return new Promise((fulfill, reject) => {
            this.request
                .post(`api/${this.apiResource}`)
                .set('api-key', 'Bearer ' + token)
                .send(modelJSON)
                .end((err, res) => {
                    if (err) reject(err);
                    fulfill(res);
                });
        });
    }

    postRelation(token, modelId, relation, modelJSON) {
        return new Promise((fulfill, reject) => {
            this.request
                .post(`api/${this.apiResource}/${modelId}/${relation}`)
                .set('api-key', 'Bearer ' + token)
                .send(modelJSON)
                .end((err, res) => {
                    if (err) reject(err);
                    fulfill(res);
                });
        });
    }

    patch(token, modelId, modelJSON) {
        return new Promise((fulfill, reject) => {
            this.request
                .patch(`api/${this.apiResource}/${modelId}`)
                .set('api-key', 'Bearer ' + token)
                .send(modelJSON)
                .end((err, res) => {
                    if (err) reject(err);
                    fulfill(res);
                });
        });
    }

    deleteById(token, modelId) {
        return new Promise((fulfill, reject) => {
            this.request
                .del(`api/${this.apiResource}/${modelId}`)
                .set('api-key', 'Bearer ' + token)
                .end((err, res) => {
                    if (err) reject(err);
                    fulfill(res);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/shared/resource-base.js